<ng-container *ngIf="product$ | async as product">
  <div class="variant-section">
    <jaga-product-variant-generic-selector
      *ngIf="product.multidimensional && product.variantMatrix?.length > 1"
      [product]="product">
    </jaga-product-variant-generic-selector>
  </div>
</ng-container>
